import * as React from "react";
import Alert from "./Alert";

const AUTO_DISMISS_MS = 5000;

const FlashMessages = (props) => {
  const [messages, setMessages] = React.useState(props.messages || []);
  const timersRef = React.useRef({});

  React.useEffect(() => {
    setMessages(props.messages || []);
  }, [props.messages]);

  React.useEffect(() => {
    const currentIds = new Set(messages.map((m) => m.id));

    Object.keys(timersRef.current).forEach((id) => {
      if (!currentIds.has(id)) {
        clearTimeout(timersRef.current[id]);
        delete timersRef.current[id];
      }
    });

    messages.forEach((msg) => {
      const duration = msg.autoHideDuration;
      if (typeof duration === "number" && duration > 0 && !timersRef.current[msg.id]) {
        timersRef.current[msg.id] = setTimeout(() => {
          setMessages((prev) => prev.filter((m) => m.id !== msg.id));
          delete timersRef.current[msg.id];
        }, duration);
      }
    });
  }, [messages]);

  const dismissToast = React.useCallback((id) => {
    if (timersRef.current[id]) {
      clearTimeout(timersRef.current[id]);
      delete timersRef.current[id];
    }
    setMessages((prev) => prev.filter((m) => m.id !== id));
  }, []);

  if (!messages || messages.length === 0) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 16,
        right: 16,
        zIndex: 1400,
        width: "clamp(240px, 90vw, 480px)",
        pointerEvents: "none",
        display: "flex",
        flexDirection: "column",
        gap: 16,
      }}
    >
      {messages.map((message) => (
        <div key={message.id} style={{ pointerEvents: "auto" }}>
          <Alert message={message} onClose={() => dismissToast(message.id)} />
        </div>
      ))}
    </div>
  );
};

export default FlashMessages;
